@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.admin

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.dto.core.KmmLong
import com.narbase.letsgo.models.audit.AuditLogEventType

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2023/05/22.
 */
class AuditLogDto(
        val id: KmmLong?,
        val createdOn: DateTimeDto,
        val adminId: KmmLong,
        @Suppress("NON_EXPORTABLE_TYPE") val eventType: DtoName<AuditLogEventType>,
        val event: String,
        val subjectId: KmmLong,
        val data: String?,
)
class ExtendedAuditLogDto(
        val entry: AuditLogDto,
        val admin: AdminDto
)